import React from 'react';
import Icon from '../Common/Icon';

/**
 * TermsContent Component
 *
 * Simplified Terms of Service content for modal display
 */
const TermsContent = () => {
  return (
    <div className="policy-content">
      <p style={{ marginBottom: '20px', fontSize: '15px' }}>
        ThryveLoop helps you test tiny ideas and discover what energizes you, without rigid goals or external pressure.
        By using ThryveLoop, you agree to these terms.
      </p>

      <h2>Four Tiers to Choose From</h2>

      <h3><Icon name="globe-2" size={18} strokeWidth={2} /> Explorer (Free)</h3>
      <p>
        Perfect for exploring. 30-day observation history, 3 active experiments, no AI.
      </p>

      <h3><Icon name="star" size={18} strokeWidth={2} /> Believer ($9/month)</h3>
      <p>
        Unlimited observations, 10 experiments, 50 AI calls/day. Bring your own API keys from OpenAI, Claude, or other providers.
      </p>

      <h3><Icon name="shield" size={18} strokeWidth={2} /> Guardian ($25/month)</h3>
      <p>
        Unlimited everything. 500 AI calls/day, advanced analytics, priority support.
      </p>

      <h3><Icon name="infinity" size={18} strokeWidth={2} /> Lifetime ($299 one-time)</h3>
      <p>
        Own it forever. All features unlimited, with optional local LLM support through our desktop app.
      </p>

      <h2>The Core Rules</h2>

      <h3>1. You Own Your Data</h3>
      <p>
        All observations, experiments, and reflections are yours alone. We don't claim ownership, have access to it, or can sell it.
      </p>

      <h3>2. Purchases & Subscriptions</h3>
      <p>
        All subscriptions and purchases are processed by Lemon Squeezy. All sales are final.
        We use PocketBase for authentication and license management only, and your personal data stays encrypted and local on your device.
      </p>

      <h3>3. No Warranties</h3>
      <p>
        ThryveLoop is provided "as is." We don't guarantee it will be bug-free, uninterrupted, or error-free.
        Built with care and intentionality, focused on your privacy and autonomy, not growth metrics.
      </p>

      <h3>4. You Use It At Your Risk</h3>
      <p>
        We're not liable for data loss, technical failures, or any outcomes from using ThryveLoop.
        Export your observations and experiments as JSON or CSV to keep them safe.
      </p>

      <h3>5. No Harmful Use</h3>
      <p>
        Don't use ThryveLoop for illegal activities, harassment, fraud, or any purpose that violates laws or harms others.
      </p>

      <h3>6. Software Licensing &amp; Third-Party Components</h3>
      <p>
        ThryveLoop is proprietary software and is not open source. Some dependencies are open source and remain governed by their own licenses.
      </p>

      <h3>7. Customer Support</h3>
      <p>
        We will do our best to respond to your query within 48 hours. Complex technical issues may take longer to fully resolve.
      </p>

      <h2>AI Co-Pilot Disclaimer</h2>

      <h3>AI is Optional (Believer, Guardian & Lifetime Plans)</h3>
      <p>
        <strong>AI is completely optional.</strong> You can use ThryveLoop without AI on any plan.
      </p>
      <p>
        <strong>Believer & Guardian users:</strong> Connect via your own API keys to cloud providers (OpenAI, Claude, DeepSeek AI, Kimi, OpenRouter, etc.).
      </p>
      <p>
        <strong>Lifetime users:</strong> Get optional local LLM support through our desktop app to run LLMs 100% offline on your device.
      </p>
      <p>
        <strong>You are always in the loop:</strong> AI suggests, you decide.
      </p>

      <h3>AI Can Be Wrong</h3>
      <p>
        Large language models make mistakes. Review AI Coach suggestions and make the final decision yourself.
      </p>

      <h3>AI Isn't Therapy</h3>
      <p>
        ThryveLoop is for curiosity, not mental health treatment. If you're struggling, please seek help from a licensed therapist.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the extent permitted by law, ThryveLoop (and its creators) are not liable for any indirect, incidental, or consequential damages.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        If we update these terms, we'll post the new version here. Continued use means you accept the changes.
        We'll always prioritize your privacy and data ownership.
      </p>
    </div>
  );
};

export default TermsContent;
